import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_SEO_GEOENTITY } from '../../routes'
import { isFranceCountryCode } from '../../routes/address/Countries'
import { selectCurrentGeoentity } from '../../store/geoentity/geoentity.selectors'
import { isEmpty } from '../../utils/lang'
import { capitalize } from '../../utils/string'
import JsonLd from '../genericComponents/JsonLD'
import { generateFullRoute } from '../router/routeUtils'

export const getStructuredBusinessType = rubricId => {
  switch (rubricId) {
    case 'hotel':
    case 'restaurant':
      return { '@type': capitalize(rubricId) }
    default:
      return { '@type': 'LocalBusiness' }
  }
}

const getStructuredAddress = (addressComponents = {}) => {
  const { way, town, postcode, countryCode } = addressComponents

  if (way && town && postcode && countryCode)
    return {
      address: {
        '@type': 'PostalAddress',
        streetAddress: way,
        addressLocality: town,
        postalCode: postcode,
        addressCountry: isFranceCountryCode(countryCode) ? 'FR' : undefined
      }
    }

  return {}
}

export const getStructuredAggregateRating = ratingComponent => {
  if (isEmpty(ratingComponent)) return {}

  const { averageNote, maxNote, numberOfReviews } = ratingComponent

  return {
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: averageNote,
      ratingCount: numberOfReviews || 1,
      bestRating: maxNote
    }
  }
}

export const getStructuredImage = imageUrl => {
  if (!imageUrl) return null

  return {
    image: [imageUrl]
  }
}

const GeoentityStructuredData = () => {
  const geoentity = useSelector(selectCurrentGeoentity)

  if (!geoentity?.name) return <></>

  const { id, name, rubric, additionalInfo, reviews } = geoentity
  const imageUrl = additionalInfo?.illustration?.url

  const data = {
    '@context': 'https://schema.org',
    ...getStructuredBusinessType(rubric?.id),
    name,
    url: generateFullRoute(ROUTE_SEO_GEOENTITY, { geoentityId: id }),
    ...getStructuredImage(imageUrl),
    ...getStructuredAddress(geoentity),
    ...getStructuredAggregateRating(reviews)
  }

  return <JsonLd data={data} />
}
export default GeoentityStructuredData
